import Main_Router from "./Routes/Route";
import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import DeltaSocketClient from "./Utils/main/DeltaSocket";
import Notfound from "./404";
import axios from "axios";
import * as Config from "./Utils/Config";
import { useDispatch } from "react-redux";

import { Get_Company_Logo } from "./ReduxStore/Slice/Admin/AdminSlice";

const App = () => {
  const dispatch = useDispatch();

  const pageRef = useRef(null);

  const [panelstatus, setPanelStatus] = useState(true);
  const [loading, setLoading] = useState(true);
  const [companyLogo, setCompanyLogo] = useState("");



  const GetCompanyStatus = async () => {
    try {
      const response = await axios.get(`${Config.base_url}get/panelstatus`);

      if (response.data?.status) {
        localStorage.setItem(
          "company_status",
          response.data?.data[0]?.isActive || 1
        );
        setPanelStatus(response.data?.data[0]?.isActive == 0 ? false : true);
      }
    } catch (error) {
      console.error("Error fetching company status:", error);
    }
  };

  const CompanyName = async () => {
    try {
      const response = await dispatch(Get_Company_Logo()).unwrap();
      if (response.status) {
        setCompanyLogo(response.data[0].landing_page_permission);
      }
    } catch (error) {
    
    }
  };

  useEffect(() => {
    CompanyName();
    GetCompanyStatus();
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="App">
      <div className="" ref={pageRef}>
        {loading && (
          <div id="startup-loader">
            <div className="coin">
              <img
                src="https://cdn3d.iconscout.com/3d/premium/thumb/bitcoin-3d-icon-png-download-12385354.png"
                alt="Loading..."
              />
            </div>
          </div>
        )}

        {/* actual page content */}
        {!panelstatus ? (
          <Notfound />
        ) : (
          <Main_Router companyLogo={companyLogo} />
        )}
      </div>
    </div>
  );
};

export default App;
